module.exports = __webpack_public_path__ + "img/stick_divers_chevron_gauche.71a2957d.svg";